module.exports = __webpack_public_path__ + "static/media/dubai_vid.05d70147.mp4";